import { SeoData } from '../interfaces/seo-data';

export const defaultseoData: SeoData = {
  title: 'Code Dimension',
  description:
    'A Code Dimension é uma plataforma focada em ensinar Front-End e Angular, através de conteúdos didáticos e relevantes!',
  image: 'https://codedimension.com.br/images/social-media-image.png',
  url: 'https://www.codedimension.com.br/',
};
